export default "__VITE_ASSET__BN$sRCV3__"